import React from 'react';
import { Button, Card, ListGroup, ListGroupItem, Modal } from 'react-bootstrap';
import moment from "moment";
import confirmDeletePPT from './confirmDeletePPt';
import ImgToolTip from '../ImgTooltip';
import getS3ImageUrl from "../../helpers/getS3ImageUrl";
import getAwsS3FileUrl from "../../helpers/getAwsS3FileUrl";

const MangagePresentations = ({ presentation, intl, presentationDeleteFileAction, handleClose, show }) => {

    async function handleDownload(file) {
        const fileURL = await getAwsS3FileUrl(file)
        window.open(fileURL, "_blank");
    }

    return (
      <Modal show={show} onHide={handleClose}>
        <Card className="download-upload-presentations">
          <Card.Header>
            {console.log("presentation------------------------------------------------------------------------------------------",presentation)}
            <span>{presentation.ppt.length}{" "}
              {intl.formatMessage({ id: 'heading.files-uploaded-for' })}{" "}
              <b>{presentation.name}</b></span>
            <Button variant="link" onClick={() => handleClose()}><img src="/icons/close-black.png" alt="close" /></Button>
          </Card.Header>
          <Card.Body>
            {/* <Row className="align-items-center">
            <Col md={4}>

            </Col>
            <Col md={8}>
              {progress > 0 && (
                <ProgressBar
                  style={{
                    display: "inline-block",
                    width: "100%",
                  }}
                  striped
                  animated
                  now={progress}
                  label={`${progress}%`}
                />
              )}
            </Col>
          </Row> */}
            <ListGroup>
              {presentation.ppt.sort((a,b) => new Date(b.date) - new Date(a.date)).map((f) => {
                return (
                    <ListGroupItem key={f.file}>
                      {intl.formatMessage({ id: 'label.file-uploaded-on' })}{" "}
                      {moment(f.date).format("DD/MM/YYYY à H:mm")}{" "}
                      <div>
                          <Button
                              onClick={() => handleDownload(f.file)}
                              className="btn btn-primary up-down"
                          >
                              <ImgToolTip
                                  intl={intl}
                                  placement="right"
                                  tooltiptext="tooltip.download.latest"
                                  id="tooltip-download-latest"
                                  img="/icons/download.png"
                              />
                          </Button>
                        <Button
                            size="small"
                            variant="link"
                            onClick={() => {
                              confirmDeletePPT(presentation._id, f.file, presentationDeleteFileAction, `Delete  ${moment(f.date).format("DD/MM/YYYY h:mm")}`);
                            }}
                        >
                          <ImgToolTip className="icon-normal" intl={intl} placement="top" tooltiptext={`button.presentation-delete-file`} id={`del-download-ppt-${f.date}`} img={`/icons/delete.png`} />
                          <ImgToolTip className="icon-hover" intl={intl} placement="top" tooltiptext={`button.presentation-delete-file`} id={`del-download-ppt-hover-${f.date}`} img={`/icons/delete-hover.png`} />
                          <ImgToolTip className="icon-focus" intl={intl} placement="top" tooltiptext={`button.presentation-delete-file`} id={`del-download-ppt-focus-${f.date}`} img={`/icons/delete-focus.png`} />
                        </Button>
                      </div>
                    </ListGroupItem>
                );
              })}
            </ListGroup>
          </Card.Body>
        </Card >
      </Modal>
  )
}

export default MangagePresentations;
